import { LucideIcon, LucideProps } from "lucide-react";
import { forwardRef } from "react";

const PowerOnPro: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  (props, ref) => {
    return (
      <svg
        {...props}
        ref={ref}
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
      >
        <path d="M590.33,496.22h-50.59v101.18h51.62c14.45,0,26.33-4.65,35.62-13.94,9.29-9.29,13.94-20.82,13.94-34.59,0-15.49-4.48-28.13-13.42-37.94-8.95-9.81-21.34-14.71-37.17-14.71Z" />
        <path d="M446.48,422.4c7.57-2.21,14.19-6.14,19.85-11.8,3.23-3.23,5.89-6.74,8-10.52,3.95-7.07,5.94-15.09,5.94-24.07,0-15.49-4.48-28.13-13.42-37.94-8.95-9.81-21.34-14.71-37.17-14.71h-50.59v101.18h51.62c5.39,0,10.41-.65,15.08-1.94.23-.06.45-.14.68-.2Z" />
        <path d="M809.88,152.7H214.12c-33.78,0-61.42,27.64-61.42,61.42v595.76c0,33.78,27.64,61.42,61.42,61.42h595.76c33.78,0,61.42-27.64,61.42-61.42V214.12c0-33.78-27.64-61.42-61.42-61.42ZM423.48,498.36h-44.39v102.21h-93.95V249.55h147.64c38.89,0,72.7,10.5,101.43,31.49,28.73,21,43.1,52.65,43.1,94.98,0,8.48-.64,16.5-1.88,24.07-1.31,7.93-3.3,15.37-5.98,22.31-7.43,19.24-20.12,34.67-38.08,46.28-25.94,16.76-54.46,26.42-85.58,28.98-5.63.46-11.35.7-17.15.7h-5.17ZM692.03,641.53c-30.63,19.79-64.87,29.68-102.73,29.68h-49.56v102.21h-93.95v-253.39c35.44-2.65,68.23-13.58,97.69-32.61,18.66-12.06,32.91-27.81,42.34-46.83,2.85-5.75,5.27-11.82,7.24-18.19h.37c38.88,0,72.7,10.5,101.43,31.49,28.73,21,43.1,52.65,43.1,94.98s-15.32,72.87-45.94,92.66Z" />
      </svg>
    );
  },
);

PowerOnPro.displayName = "PowerOnPro";

export default PowerOnPro;
